import script from "./OfferCompareSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferCompareSection.vue?vue&type=script&setup=true&lang=js"

import "./OfferCompareSection.vue?vue&type=style&index=0&id=1f2836ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2836ea"]])

export default __exports__